<h5>Team Metrics</h5>

<div class="alert alert-info">
  Attendance Issues: <strong>{{ issues }}</strong>
</div>

<button class="btn btn-primary btn-sm"
        (click)="resolveIssue()">
  Resolve Issue
</button>
